'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _style = require('./style.css');

var _style2 = _interopRequireDefault(_style);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _bind2.default.bind(_style2.default);

var Loader = function Loader(_ref) {
  var _ref$appearance = _ref.appearance,
      appearance = _ref$appearance === undefined ? 'spinner' : _ref$appearance,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 'md' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? 'gray' : _ref$color,
      _ref$fullscreen = _ref.fullscreen,
      fullscreen = _ref$fullscreen === undefined ? false : _ref$fullscreen,
      _ref$centered = _ref.centered,
      centered = _ref$centered === undefined ? false : _ref$centered;
  return _react2.default.createElement(
    'div',
    {
      className: cx('xsui-loader', fullscreen && 'xsui-loader--fullscreen', centered && 'xsui-loader--centered') },
    appearance === 'spinner' && _react2.default.createElement('div', {
      className: cx('xsui-loader__spinner', 'xsui-loader__spinner--size-' + size, 'xsui-loader__spinner--color-' + color)
    }),
    appearance === 'dots' && new Array(3).fill(null).map(function (dot, index) {
      return _react2.default.createElement('div', {
        key: 'dot--' + index,
        className: cx('xsui-loader__dot', 'xsui-loader__dot--size-' + size, 'xsui-loader__dot--color-' + color)
      });
    })
  );
};

Loader.propTypes = {
  appearance: _propTypes2.default.oneOf(['spinner', 'dots']),
  size: _propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xlg']),
  color: _propTypes2.default.oneOf(['black', 'blue', 'gray', 'dark-gray', 'white', 'inherit']),
  fullscreen: _propTypes2.default.bool,
  centered: _propTypes2.default.bool
};
exports.default = Loader;